import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { IMenuRouteInfo } from '../../interfaces/menu.interface'

@UntilDestroy()
@Component({
  selector: 'lla-sidemenu-bottom-sheet',
  templateUrl: './sidemenu-bottom-sheet.component.html',
  styleUrls: ['./sidemenu-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidemenuBottomSheetComponent {
  constructor(
    public bottomSheetRef: MatBottomSheetRef<SidemenuBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { items: IMenuRouteInfo[] }
  ) {}
}
